import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import getContentAreaFromSpread from 'editor/src/store/design/util/getContentAreaFromSpread';
import getCurrentSpreadIndex from 'editor/src/store/editor/selector/getCurrentSpreadIndex';
import getFocusedContent from 'editor/src/store/editor/selector/getFocusedContent';
import saveUndoRedoStateOperation from 'editor/src/store/editorModules/undoRedo/operation/saveUndoRedoStateOperation';
import getRollLength from 'editor/src/store/gangSheet/selector/getRollLength';
import getSheetArtworkRects from 'editor/src/store/gangSheet/util/getSheetArtworkRects';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import { clampSheetLengthMm, getArtworkLengthMm } from 'editor/src/util/gangSheet/rollingSheetLength';

import setSheetLengthOperation from './setSheetLengthOperation';

// "Fit length": trims a rolling gang sheet to its lowest artwork edge (never below the
// minimum length), e.g. after artwork was deleted. Nothing on the sheet moves and nothing
// is cropped. One undo step.
const fitSheetLengthToArtworkOperation = () => (dispatch: ThunkDispatch, getState: () => RootState) => {
  const state = getState();
  const rollLength = getRollLength(state);
  const spread = state.design.designData?.spreads[getCurrentSpreadIndex(state)];
  const area = getContentAreaFromSpread(spread, getFocusedContent(state));
  if (!rollLength || !area) {
    return;
  }

  const target = clampSheetLengthMm(getArtworkLengthMm(getSheetArtworkRects(spread, area)), rollLength);
  if (Math.abs(target - area.height) <= 1e-6) {
    return;
  }

  batch(() => {
    dispatch(saveUndoRedoStateOperation('Fit sheet length'));
    dispatch(setSheetLengthOperation(target));
  });
};

export default fitSheetLengthToArtworkOperation;
